import { useTheme } from '@emotion/react';
import { Tooltip } from '@mui/material';
import React from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { setReservationClientVoucherVisibility, setReservationOverviewVisibility } from 'src/store/reservations/slices/hotels/HotelDetailSlice';

const CustomClientVoucherReference = ({voucherId, itemReference}) => {
   const theme = useTheme();
    const dispatch = useDispatch();
    const { id } = useParams();

    const handleClick = () => {
        dispatch(setReservationOverviewVisibility(false));
        dispatch(setReservationClientVoucherVisibility(true));
    };

    return (
        <Tooltip title={`Element Reference No: ${itemReference}`}>
            <Link
                to={`/reservations/${id}/client-voucher/${voucherId}/voucher-items/${itemReference}`}
                onClick={handleClick}
                style={{ color: theme.palette.text.info }}
                variant="body2"

            >
                {itemReference}
            </Link>
        </Tooltip>
    );
}

export default CustomClientVoucherReference